import React, { useState } from 'react'
import MainFooter from '../Components/footer/MainFooter'
import TopNavigation from '../Components/navigation/TopNavigation'
import AuthLogin from '../Components/auth/AuthLogin';
import AuthRegister from '../Components/auth/AuthRegister';
import AuthReset from '../Components/auth/AuthReset';
import { Helmet } from 'react-helmet';

function AuthenticateScreen() {
    
  const [activeTab, setActiveTab]                           = useState('login');
  
  return (
    <div className="main-layer">
        <Helmet>
          <title>Lovedripp - Authenticate </title>
        </Helmet>
       <TopNavigation title={"Authenticate"} classBack="full-white"/>
        <div className="content-layer">
            <div className="section-item">
                <div className="container auth-container">

                    <ul className="nav nav-tabs">
                        <li className="nav-item">
                        <button
                            className={`nav-link ${activeTab === 'login' ? 'active' : ''}`}
                            onClick={() => setActiveTab('login')}
                        >
                            Login
                        </button>
                        </li>
                        <li className="nav-item">
                        <button
                            className={`nav-link ${activeTab === 'register' ? 'active' : ''}`}
                            onClick={() => setActiveTab('register')}
                        >
                            Register
                        </button>
                        </li>
                        <li className="nav-item">
                        <button
                            className={`nav-link ${activeTab === 'forgot' ? 'active' : ''}`}
                            onClick={() => setActiveTab('forgot')}
                        >
                            Forgot Password
                        </button>
                        </li>
                    </ul>
        
                    <div className="tab-content p-3 border border-top-0 rounded-bottom creamyback">
                        {activeTab === 'login' && (
                         <div className="body-auth">
                            <AuthLogin />
                         </div>
                        )}

                        {activeTab === 'register' && (
                         <div className="body-auth">
                            <AuthRegister />
                         </div>
                        )}

                        {activeTab === 'forgot' && (
                         <div className="body-auth">
                            <AuthReset />
                         </div>
                        )}
                    </div>

                        </div>
                    </div>
        </div>
       <MainFooter />
    </div>
  )
}

export default AuthenticateScreen